import Chatbot from './chatbot.js';
if ( iPortalCore.settings.chatbotEnabled ) {
	new Chatbot();
}

import Search from './search.js';
new Search();
